import emoji1f600 from '@twemoji/svg/1f600.svg';
import emoji1f604 from '@twemoji/svg/1f604.svg';
import emoji1f601 from '@twemoji/svg/1f601.svg';
import emoji1f60a from '@twemoji/svg/1f60a.svg';
import emoji1f609 from '@twemoji/svg/1f609.svg';
import emoji1f60d from '@twemoji/svg/1f60d.svg';
import emoji1f970 from '@twemoji/svg/1f970.svg';
import emoji1f60e from '@twemoji/svg/1f60e.svg';
import emoji1f929 from '@twemoji/svg/1f929.svg';
import emoji1f973 from '@twemoji/svg/1f973.svg';
import emoji1f917 from '@twemoji/svg/1f917.svg';
import emoji1f913 from '@twemoji/svg/1f913.svg';
import emoji1f63a from '@twemoji/svg/1f63a.svg';
import emoji1f98a from '@twemoji/svg/1f98a.svg';
import emoji1f43c from '@twemoji/svg/1f43c.svg';
import emoji1f428 from '@twemoji/svg/1f428.svg';
import emoji1f438 from '@twemoji/svg/1f438.svg';
import emoji1f984 from '@twemoji/svg/1f984.svg';
import emoji1f419 from '@twemoji/svg/1f419.svg';
import emoji1f98b from '@twemoji/svg/1f98b.svg';
import emoji1f41d from '@twemoji/svg/1f41d.svg';
import emoji1f42c from '@twemoji/svg/1f42c.svg';
import emoji1f99c from '@twemoji/svg/1f99c.svg';
import emoji1f432 from '@twemoji/svg/1f432.svg';
import emoji1f916 from '@twemoji/svg/1f916.svg';
import emoji1f47d from '@twemoji/svg/1f47d.svg';
import emoji1f6f8 from '@twemoji/svg/1f6f8.svg';
import emoji1f680 from '@twemoji/svg/1f680.svg';
import emoji1fa90 from '@twemoji/svg/1fa90.svg';
import emoji1f319 from '@twemoji/svg/1f319.svg';
import emoji2b50 from '@twemoji/svg/2b50.svg';
import emoji26a1 from '@twemoji/svg/26a1.svg';
import emoji1f52e from '@twemoji/svg/1f52e.svg';
import emoji1f4ab from '@twemoji/svg/1f4ab.svg';
import emoji1f30c from '@twemoji/svg/1f30c.svg';
import emoji1f9ec from '@twemoji/svg/1f9ec.svg';
import emoji1f4dd from '@twemoji/svg/1f4dd.svg';
import emoji1f389 from '@twemoji/svg/1f389.svg';
import emoji1f4e2 from '@twemoji/svg/1f4e2.svg';
import emoji1f38a from '@twemoji/svg/1f38a.svg';
import emoji1f642 from '@twemoji/svg/1f642.svg';
import emoji2728 from '@twemoji/svg/2728.svg';
import emoji1f308 from '@twemoji/svg/1f308.svg';

const EMOJI_ASSETS: Readonly<Record<string, string>> = {
  '😀': emoji1f600,
  '😄': emoji1f604,
  '😁': emoji1f601,
  '😊': emoji1f60a,
  '😉': emoji1f609,
  '😍': emoji1f60d,
  '🥰': emoji1f970,
  '😎': emoji1f60e,
  '🤩': emoji1f929,
  '🥳': emoji1f973,
  '🤗': emoji1f917,
  '🤓': emoji1f913,
  '😺': emoji1f63a,
  '🦊': emoji1f98a,
  '🐼': emoji1f43c,
  '🐨': emoji1f428,
  '🐸': emoji1f438,
  '🦄': emoji1f984,
  '🐙': emoji1f419,
  '🦋': emoji1f98b,
  '🐝': emoji1f41d,
  '🐬': emoji1f42c,
  '🦜': emoji1f99c,
  '🐲': emoji1f432,
  '🤖': emoji1f916,
  '👽': emoji1f47d,
  '🛸': emoji1f6f8,
  '🚀': emoji1f680,
  '🪐': emoji1fa90,
  '🌙': emoji1f319,
  '⭐': emoji2b50,
  '⚡': emoji26a1,
  '🔮': emoji1f52e,
  '💫': emoji1f4ab,
  '🌌': emoji1f30c,
  '🧬': emoji1f9ec,
  '📝': emoji1f4dd,
  '🎉': emoji1f389,
  '📢': emoji1f4e2,
  '🎊': emoji1f38a,
  '🙂': emoji1f642,
  '✨': emoji2728,
  '🌈': emoji1f308,
};

export function getEmojiAssetUrl(emoji: string): string | undefined {
  return EMOJI_ASSETS[emoji.replace(/\uFE0F/g, '')];
}

